import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { usePublishBottomNavbarHeight } from 'components/navbars/BottomNavbar';
import {
  ProcessingBar,
  ProcessingBarContent,
  ProcessingDescription,
  ProcessingIcon,
  ProcessingTitle,
} from './SummaryProcessingBar.styles';

export const SummaryProcessingBar = () => {
  const { t } = useTranslation();
  const barRef = useRef<HTMLDivElement>(null);
  usePublishBottomNavbarHeight(barRef);

  return (
    <ProcessingBar ref={barRef}>
      <ProcessingBarContent>
        <ProcessingIcon />
        <div>
          <ProcessingTitle>{t('recording.processing.title')}</ProcessingTitle>
          <ProcessingDescription>{t('recording.processing.description')}</ProcessingDescription>
        </div>
      </ProcessingBarContent>
    </ProcessingBar>
  );
};
